import {
    IonButton,
    IonCol,
    IonInput,
    IonItem,
    IonLabel,
    IonRow,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import { UpdateEventInput } from "../../API";
import { Event } from "../../models";
import { updateEvent } from "../../utilities/events/Event";
import ErrorAlert from "../Errors/ErrorAlert";
import Spinner from "../Spinners/Spinner";

interface _Props {
    event: Event
}

const EventUSEFSettingsForm: React.FC<_Props> = ({event}) => {

    const [isDisabled, setIsDisabled] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [number, setNumber] = useState<string>("");
    const [softwareKey, setSoftwareKey] = useState<string>("");
    const [error, setError] = useState<string>("");


    useEffect(() => {
        if (event) {
            if (event.usefID) setNumber(event.usefID);
            if (event.usefSoftwareKey) setSoftwareKey(event.usefSoftwareKey);
        }
    }, [event]);

    const handleSave = async () => {
        const input: UpdateEventInput = {
            id: event.id,
            usefID: number,
            usefSoftwareKey: softwareKey
        };
        const updateResult = await updateEvent(input);
        if (updateResult.isSuccess) {
            setIsDisabled(true);
        } else {
            setError("Could not save the USEF Settings.");
        }
    }

    const handleSubmit = async () => {
        setIsLoading(true);
        setError("");
        await handleSave();
        setIsLoading(false);
    }

    return (
        <>
            {error && <ErrorAlert width="12" error={error}/>}
            <IonRow>
                <IonCol sizeMd="12">
                    <IonItem color="white">
                        <IonLabel position="stacked">USEF Comp ID</IonLabel>
                        <IonInput 
                            type="text"
                            value={number}
                            aria-required={true}
                            onIonChange={e => {
                                setIsDisabled(false);
                                setNumber(e.detail.value!)
                            }}
                        />
                    </IonItem>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol sizeMd="12">
                    <IonItem color="white">
                        <IonLabel position="stacked">USEF Software Key</IonLabel>
                        <IonInput 
                            type="text"
                            value={softwareKey}
                            aria-required={true}
                            onIonChange={e => {
                                setIsDisabled(false);
                                setSoftwareKey(e.detail.value!)
                            }}
                        />
                    </IonItem>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol sizeMd="4">
                    {isLoading ?
                        <Spinner />
                        :
                        <IonButton
                            disabled={isDisabled}
                            className="ion-margin-top"
                            color="tertiary"
                            expand="block"
                            onClick={handleSubmit}
                        >
                            {isDisabled ? "Saved" : "Save"}
                        </IonButton>
                    }
                </IonCol>
            </IonRow>
        </>
    );
};

export default EventUSEFSettingsForm;